import { useContext, useEffect, useRef, useState } from 'react';
// import { Editor } from '@tinymce/tinymce-react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Alignment, Bold, ClassicEditor, Essentials, FontColor, Heading, Italic, Mention, Paragraph, Undo } from 'ckeditor5';
import '../classes/styles/style.css';
import Screen from '../components/screen';
import * as WS from '../webServices/cyMyManager';
// import { Editor as EditorRef } from "tinymce/tinymce";
import { GetGlobalContext, GlobalContextData } from '../classes/context';
import { useNavigate } from 'react-router';
import 'ckeditor5/ckeditor5.css';

export default function Home() {
    const globalContext = useContext<GlobalContextData>(GetGlobalContext);

    // const editorRef = useRef<EditorRef | undefined>(undefined);
    const [editorText, setEditorText] = useState("")
    const [hideEdit, setHideEdit] = useState<boolean>(true);

    const [numClienti, setNumClienti] = useState<number>();
    const [numOrdini, setNumOrdini] = useState<number>();
    const [numAbbAttivi, setNumAbbAttivi] = useState<number>();
    const [numPrenot, setNumPrenot] = useState<number>();

    const [imageBase64, setImageBase64] = useState<string | null>(globalContext.vars.esercente?.imgFile ?? null);

    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            const reader = new FileReader();
            reader.onload = (loadEvent: any) => {
                if (loadEvent.target.result.length > 1398101) // 1Mb * 4 / 3
                    alert('Il file indicato è troppo grande, selezionare un file di massimo 1Mb.')
                else
                    setImageBase64(loadEvent.target.result.split(',')[1] ?? '');
            };
            reader.readAsDataURL(file);
        }
    };

    const fileInputRef = useRef<HTMLInputElement>(null);

    const triggerFileSelect = () => fileInputRef.current?.click();

    const onSave = async () => {
        if (!globalContext.vars.esercente) return;
        let newEdit = globalContext.vars.esercente

        // newEdit.Info = editorRef.current?.getContent() ?? ""
        newEdit.Info = editorText
        newEdit.imgFile = imageBase64 ?? ''

        try {
            let res = await WS.Plus.updateEsercente(WS.UT.TOKEN, newEdit)
            if (res.isOk)
                alert('Salvataggio Riuscito')
            else
                alert(res.msgErr)
        } catch (e) {
            alert(e)
        }
    }

    const onload = async () => {
        let listSedi = await WS.Plus.getListaSediEsercenti(WS.UT.TOKEN, "", globalContext.vars.esercente?.Id ?? 0, 0, 0, 1, 0);

        let listaAbb: WS.Plus.IF.AbbonamVendTest[] = [];
        let eleCli: number[] = [];
        for (let index = 0; index < listSedi.list.length; index++) {
            let listaAbbSede = await WS.Plus.getListaAbbonamVend(WS.UT.TOKEN, 0, '', '', '', '', 0, 0, 0, listSedi.list[index].Id, '', 0, 0, 0);

            listaAbbSede.list.forEach(l => {
                if (!eleCli.includes(l.IdCliente))
                    eleCli.push(l.IdCliente)
            })
            listaAbb = listaAbb.concat(listaAbbSede.list);
        }

        setNumClienti(eleCli.length);
        setNumOrdini(listaAbb.length);
        setNumAbbAttivi(listaAbb.filter(x =>
            x.DataSca >= (new Date()).toJSON().substring(0, 10) &&
            x.Stato !== WS.Plus.IF.StatoAbbVen.Sospeso &&
            (x.Contatore <= x.Quantita || x.tipoAbb == WS.Plus.IF.TipoAbbonamento.ATempo)
        ).length)

        // Il numero prenotazioni è da rivedere
        let resPren = await WS.Plus.getListPrenotazioni(WS.UT.TOKEN, (new Date()).toJSON().substring(0, 10), 0, 0, '', '');
        if (resPren.isOk){
            const sediIds = listSedi.list.map(sede => sede.Id);
            const filteredPrenotazioni = resPren.list.filter(prenotazione =>
                sediIds.includes(prenotazione.IdSedeEserc)
            );
            setNumPrenot(filteredPrenotazioni.length);
            console.log(resPren.list)
        }

    }

    useEffect(() => {
        onload();
    }, []);

    return (
        <Screen>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12'>
                        <div className='card d-flex flex-column flex-md-row justify-content-between'>
                            <h2>Benvenuto {globalContext.vars.esercente?.RagSoc ?? ''}</h2>
                            <div className='ms-auto'>
                                <a className='btn btn-primary' href='https://allyoucarwash.com/static/partner/aycw_scanner.apk' target='_blank'> <i className="bi bi-phone-fill me-2" style={{color: 'white'}}></i>Scarica l'app scanner</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className='col-12 col-md-3'>
                        <div className='card'>
                            <div className='text-center'>
                                <h5 className='m-0'>Clienti </h5>
                            </div>
                            <div className='card-counter'>
                                <span>{numClienti}</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-md-3'>
                        <div className='card'>
                            <div className='text-center'>
                                <h5 className='m-0'>Abbonamenti Attivi</h5>
                            </div>
                            <div className='card-counter'>
                                <span>{numAbbAttivi}</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-md-3'>
                        <div className='card'>
                            <div className='text-center'>
                                <h5 className='m-0'>Ordini</h5>
                            </div>
                            <div className='card-counter'>
                                <span>{numOrdini}</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-md-3'>
                        <div className='card'>
                            <div className='text-center'>
                                <h5 className='m-0'>Prenotazioni</h5>
                            </div>
                            <div className='card-counter'>
                                <span>{numPrenot}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className='col-12'>
                        <div className='card d-flex justify-content-between flex-row align-items-center'>
                            <h5>Profilo Esercente </h5>
                            <div className='wrapper-action-btn'>
                                <button className='btn btn-success' onClick={onSave}>
                                    <i className="bi bi-floppy me-2"></i>
                                    <span>Salva</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className={'col-12'}>
                        <CKEditor
                            editor={ClassicEditor}
                            onChange={(evt, editor) => {
                                setEditorText(editor.getData())
                            }}
                            config={{
                                toolbar: {
                                    items: ['undo', 'redo', '|', 'heading' , 'bold', 'italic', '|', 'fontColor', 'alignment'],
                                },
                                plugins: [
                                     Bold, Essentials, Italic, Mention, Paragraph, Undo, Heading, FontColor, Alignment,
                                 ],
                                // mention: {
                                //     // Mention configuration
                                // },
                                initialData: globalContext.vars.esercente?.Info ?? '',
                            }}
                        />
                        {/* <Editor
                            apiKey='5lw8qa6a4fg7sdr0a35o79qbjzlkx6f12hi9j8ul39wfieeg'
                            onInit={(evt, editor) => {
                                editorRef.current = editor;
                                setHideEdit(false);
                            }}
                            initialValue={globalContext.vars.esercente?.Info ?? ''}
                            init={{
                                height: 500,
                                width: '100%',
                                menubar: false,
                                plugins: [
                                    // Elenco dei plugin
                                ],
                                toolbar: 'undo redo | blocks | ' +
                                    'bold italic forecolor | alignleft aligncenter ' +
                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                    'removeformat | help | myCustomButton',
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                            }}
                        /> */}
                    </div>
                </div>
                <div className='col-12' style={{ marginTop: '20px' }}>
                    <div className='card d-flex justify-content-between flex-row align-items-center'>
                        <h5>Logo esercente</h5>
                        <div className='wrapper-action-btn'>
                            <button className='btn btn-success' onClick={triggerFileSelect}>
                                <i className="bi bi-pencil"></i>
                                <span> Seleziona</span>
                            </button>
                        </div>
                    </div>
                    <div className="image-container" style={{ border: '1px solid #ccc', minHeight: '200px', maxHeight: '400px', position: 'relative', alignContent: 'center' }}>
                        {imageBase64 ? (
                            <img src={'data:image/png;base64,' + imageBase64} alt="Logo Esercente" style={{ width: '100%', height: '100%', maxHeight: '350px', objectFit: 'contain' }} />
                        ) : (
                            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <span>Nessuna immagine</span>
                            </div>
                        )}
                        <input
                            type="file"
                            ref={fileInputRef}
                            onChange={handleImageChange}
                            style={{ display: 'none' }}
                            accept="image/*"
                        />
                    </div>
                </div>
            </div>
        </Screen>
    );
}



